<template>
  <div :class="blockClass">
    <sample-audio-player
      :audio-url="audioUrl"
      :book-slug="bookSlug"
      :theme="theme"
      block-name="books-preview-player"
      event-name="body-20190328-books_preview_audio_player"
      :play-button-classes="playButtonClasses"
    />
    <div :class="`books-preview-audio__label ${labelClasses}`" v-html="computedLabel" />
  </div>
</template>

<script>
import SampleAudioPlayer from "@/shared/audio-player/sample-audio-player"
import bemBlockMofifiers from "@/utils/bem-block-modifiers"

export default {
  name: "BooksPreviewAudio",
  components: { SampleAudioPlayer },
  props: {
    bookSlug: { type: String, default: null },
    label: { type: String, default: null },
    theme: { type: String, default: "light" },
    modifiers: { type: Array, default: () => [] },
    playButtonClasses: {
      type: String,
      default: ""
    },
    labelClasses: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      audioUrl: null
    }
  },
  computed: {
    computedLabel() {
      return this.label || this.$t("label")
    },
    blockClass() {
      return bemBlockMofifiers("books-preview-audio", this.modifiers)
    }
  },
  i18n: {
    messages: {
      en: {
        label: "Listen to key idea 1"
      },
      de: {
        label: "Diese Kernaussage anhören"
      },
      es: {
        label: "Escucha la idea clave 1"
      }
    }
  }
}
</script>

<style lang="scss">
.books-preview-audio {
  position: relative;

  margin-bottom: $spacing-32;

  &__label {
    @include font-family(sans-serif);
    @include font-style(caption, $color: $dark-grey);

    position: absolute;
    top: base(0.5);
    left: base(10); // $basex8 + $basex2
  }

  &--mb24 {
    margin-bottom: $basex3;
  }
}

.books-preview-player {
  $root: &;

  @include font-family(sans-serif);

  display: flex;
  align-items: center;

  &--dark {
    #{$root}__element {
      &--play {
        border: 0;
      }
    }

    #{$root}__play {
      background-image: url("~@images/books-preview/play-dark.svg");
      background-repeat: no-repeat;
      background-position: 50% 50%;

      &:hover {
        background-image: url("~@images/books-preview/play-dark-hover.svg");
      }
    }

    #{$root}__pause {
      background-image: url("~@images/books-preview/pause-dark.svg");
      background-position: center;

      &:hover {
        background-image: url("~@images/books-preview/pause-dark-hover.svg");
      }
    }
  }

  &__element {
    &--play {
      width: $basex8;
      height: $basex8;
      margin-right: $basex2;

      background-color: $deep-black;

      border-radius: 50%;
    }

    &--progress {
      flex-grow: 1;
      margin-right: $base;
    }

    &--time {
      margin-right: $base;

      color: $black;
    }

    &--total {
      color: $black;

      @include media(max-width, m) {
        padding-right: 0;
      }
    }

    &:not(&--play) {
      margin-top: $basex2;
    }
  }

  &__play {
    display: block;

    width: 100%;
    height: 100%;

    background-color: transparent;
    background-image: url("~@images/books-preview/play.svg");
    background-repeat: no-repeat;
    background-position: 60% 50%;

    border: 0;

    cursor: pointer;

    &:hover {
      background-image: url("~@images/books-preview/play-hover.svg");
    }
  }

  &__pause {
    background-image: url("~@images/books-preview/pause.svg");
    background-position: center;

    &:hover {
      background-image: url("~@images/books-preview/pause-hover.svg");
    }
  }

  &__remaining-time {
    min-width: 3em;
  }

  &__progress {
    width: 100%;
  }

  &__volume {
    width: 100%;
  }

  .ranger {
    &__path {
      height: 5px;

      background: $lightest-grey;

      border-radius: $spacing-4;
    }
  }
}
</style>
